import React from "react";
import "./App.css";

//main app, just displays Main component which will switch components based on route
function App() {
  return (
    <div id={"App"} className={"App"}>
      Hi
    </div>
  );
}

export default App;
